/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  if (/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)) {
    return false
  } else {
    return '邮箱格式不正确'
  }
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  if (/^1[0-9]{10}$/.test(s)) {
    return false
  } else {
    return '手机号码格式不正确'
  }
}

/**
 * 手机号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 校验正整数 包含0
 * @param {*} s
 */
export function isInt (s) {
  if (/^\d+$/.test(s)) {
    return false
  } else {
    return '不是整数'
  }
}

/**
 * 校验时间段格式
 * @param {*} s
 */
export function isTime (s) {
  return false
  if (/^1[0-9]{10}$/.test(s)) {
    return false
  } else {
    return '时间格式不正确'
  }
}

/**
 * 校验价格段格式
 * @param {*} s
 */
export function isPrice (s) {
  if(s <= 0) {
    return '数值要大于0'
  }
  if (/^[0-9]+(\.[0-9]{1,2})?$/.test(s)) {
    return false
  } else {
    return '最多保留两位小数'
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js